/* Reuse confirmed, product-specific size data; never generate measurements. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.mv-empty-cart-continue');
    if (!button) return;
    var drawer = button.closest('cart-drawer');
    var nativeClose = drawer && drawer.querySelector('.drawer__close[data-cart-drawer-close]');
    if (nativeClose) { event.preventDefault(); nativeClose.click(); }
  });
  function cleanDescription(root) {
    if (root.dataset.mvCleaned) return;
    root.dataset.mvCleaned = 'true';
    root.querySelectorAll('[style]').forEach(function (element) {
      if (!element.closest('.mv-size-chart') && !element.closest('table')) element.removeAttribute('style');
    });
    root.querySelectorAll('img').forEach(function (image) {
      var chart = image.closest('.mv-size-chart') || /tagli|guida|size[ _-]*(chart|guide)|sizing|measurement|misur/i.test((image.getAttribute('src') || '') + ' ' + (image.alt || ''));
      var paragraph = image.closest('p');
      if (!chart) {
        image.remove();
        if (paragraph && !paragraph.textContent.trim() && !paragraph.querySelector('img,table')) paragraph.remove();
        return;
      }
      image.classList.add('mv-description-chart-image');
      image.removeAttribute('width');image.removeAttribute('height');
      function failed() { image.remove();if(paragraph && !paragraph.textContent.trim() && !paragraph.querySelector('img,table'))paragraph.remove(); }
      image.addEventListener('error', failed, {once:true});
      if (image.complete && !image.naturalWidth) failed();
    });
    var leadingHeading=root.firstElementChild;
    if(leadingHeading && /^H[1-6]$/.test(leadingHeading.tagName) && root.dataset.mvProductTitle)leadingHeading.textContent=root.dataset.mvProductTitle.replace(/\s*\|\s*/,' — ');
    root.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
      var paragraph = document.createElement('p');var strong = document.createElement('strong');
      strong.innerHTML = heading.innerHTML;paragraph.appendChild(strong);heading.replaceWith(paragraph);
    });
    root.querySelectorAll('p').forEach(function (paragraph) {
      if (/^[\s\S]*[✔✓]/.test(paragraph.textContent) && paragraph.querySelector('br')) {
        var parts = paragraph.innerHTML.split(/(?:<br\s*\/?>(?:\s|&nbsp;)*)+/i).filter(function (part) { return part.replace(/<[^>]*>/g,'').trim(); });
        if (parts.length > 1 && parts.every(function (part) { return /^[\s]*(?:✔|✓)/.test(part); })) {
          var list = document.createElement('ul');parts.forEach(function (part) { var item=document.createElement('li');item.innerHTML=part.replace(/^[\s]*(?:✔|✓)\s*/, '');list.appendChild(item); });paragraph.replaceWith(list);
        }
      }
      if (/acquista\s+solo\s+oggi|nostro\s+sconto\s+esclusivo/i.test(paragraph.textContent)) paragraph.remove();
    });
    root.querySelectorAll('p,div').forEach(function(element){if(!element.textContent.trim() && !element.querySelector('img,table') && !element.hasAttribute('data-mv-confirmed-chart'))element.remove();});
    var details=root.closest('details');var body=details && details.querySelector('[data-collapsible-body]');
    if(body && details.getAttribute('open') === 'true')body.style.height='auto';
  }
  document.addEventListener('change',function(event){
    var input=event.target;if(!input.matches('[data-single-option-selector]'))return;
    var button=input.closest('.mv-color-image-button'),image=button&&button.querySelector('[data-mv-fallback-color]');
    if(!image)return;var product=input.closest('product-component'),media=image.dataset.mvColorMediaId;
    if(!product||!media)return;
    setTimeout(function(){if(!input.checked)return;var thumb=Array.from(product.querySelectorAll('[data-thumb-link]')).find(function(t){return t.dataset.mediaId.endsWith('-'+media);});if(thumb)thumb.click();},50);
  });
  function displaySize(value, jewelry) {
    if (jewelry) {
      var italian = String(value || '').match(/^\s*IT\s*:?\s*(\d+(?:[.,]\d+)?)/i);
      return italian ? italian[1] : value;
    }
    var match=String(value||'').match(/^IT\s*\d+(?:\s*[-–]\s*\d+)?\s*\((XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)\)/i);
    return match?match[1].toUpperCase().replace(/^XXXL$/,'3XL').replace(/^XXL$/,'2XL'):value;
  }
  function sizeLabels(){document.querySelectorAll('.selector-wrapper--size').forEach(function(w){var jewelry=w.classList.contains('selector-wrapper--jewelry-size');w.querySelectorAll('label').forEach(function(l){var input=document.getElementById(l.htmlFor),title=l.querySelector('.option-title');if(input&&title)title.textContent=displaySize(input.value,jewelry);});w.querySelectorAll('[data-popout-option]').forEach(function(a){var text=a.querySelector('span');if(text)text.textContent=displaySize(a.dataset.value,jewelry);});w.querySelectorAll('[data-option-value],[data-popout-toggle-text]').forEach(function(el){el.textContent=displaySize(el.textContent,jewelry);});});}
  document.addEventListener('change',function(event){if(event.target.matches('[data-single-option-selector]'))setTimeout(sizeLabels,0);});
  function init() {
    sizeLabels();
    if (document.getElementById('pp-tracking-page-app')) document.body.classList.add('mv-tracking-page');
    document.querySelectorAll('.mv-description-copy').forEach(cleanDescription);
    document.querySelectorAll('.product__content').forEach(function (product) {
      var chart = product.querySelector('.mv-size-chart[data-mv-confirmed-chart]');
      if (!chart) return;
      var wrapper = Array.from(product.querySelectorAll('.selector-wrapper')).find(function (element) {
        var label = element.querySelector('.radio__legend__option-name,.select__label');
        return element.classList.contains('selector-wrapper--size') || /^(taglia|taglie|size|taille|tamanho|gr[oö]sse)$/i.test((label && label.textContent || '').trim());
      });
      var legend = wrapper && wrapper.querySelector('.radio__legend');
      if (!legend || legend.querySelector('.mv-confirmed-size-link')) return;
      legend.classList.add('mv-kiwi-size-legend');
      var button = document.createElement('button');
      button.type = 'button';button.className = 'mv-confirmed-size-link';button.textContent = 'Guida alle taglie';
      button.addEventListener('click', function () {
        var details = chart.closest('details');
        if (details && !details.open) { var summary=details.querySelector('summary'); if(summary)summary.click(); }
        var tab = chart.closest('.tab-content');
        if(tab && !tab.classList.contains('current')){var link=product.querySelector('[data-tab="'+tab.className.match(/tab-content-(\d+)/)?.[1]+'"]');if(link)link.click();}
        window.setTimeout(function(){chart.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});},250);
      });
      legend.appendChild(button);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('theme:product:loaded',init);
})();
